var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99944 17.9989C13.9697 17.9989 17.9989 13.9697 17.9989 8.99944C17.9989 4.02919 13.9697 0 8.99944 0C4.02919 0 0 4.02919 0 8.99944C0 13.9697 4.02919 17.9989 8.99944 17.9989Z",
    fill: "#F04086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1833 9.42409C12.8289 9.03259 12.3193 8.78959 11.6533 8.69509V8.68103C12.2366 8.58653 12.6951 8.34747 13.0067 7.96497C13.323 7.58563 13.4947 7.10659 13.4916 6.61272C13.4916 5.7909 13.2272 5.23234 12.6793 4.79303C12.1314 4.35428 11.3091 4.20972 10.1948 4.20972H5.98669V8.1264H3.57019V9.62659H10.1666C10.6858 9.62659 11.0756 9.66315 11.3333 9.87072C11.5909 10.0783 11.7225 10.3466 11.7225 10.7432C11.7225 11.1397 11.5926 11.4783 11.3333 11.691C11.0745 11.903 10.6841 12.0431 10.1666 12.0431H7.90313V10.8765H5.98669V13.5433H10.3331C11.4384 13.5433 12.2833 13.2547 12.8694 12.8064C13.455 12.3581 13.7301 11.696 13.7301 10.8832C13.7373 10.3455 13.5422 9.82464 13.1833 9.42409ZM9.92475 8.12247H7.90313V5.70597H9.92475C10.9643 5.70597 11.4829 6.11153 11.4829 6.91422C11.4829 7.7169 10.9643 8.12247 9.92475 8.12247Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcn);
export default __webpack_public_path__ + "static/media/bcn.3094e5eff29fba10790f97fc2b7fd7e5.svg";
export { ForwardRef as ReactComponent };